import { cn } from '../../lib/utils';
import { HTMLAttributes } from 'react';

export interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  className?: string;
}

export interface CardSectionProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  subtitle?: string;
}

export function Card({ children, className, ...props }: CardProps) {
  return (
    <div className={cn('bg-tf-bg-card rounded-lg border border-tf-border shadow-sm', className)} {...props}>
      {children}
    </div>
  );
}

export function CardSection({ children, className, title, subtitle }: CardSectionProps) {
  return (
    <div className={cn('p-5 border-b border-tf-border last:border-b-0', className)}>
      {(title || subtitle) && (
        <div className="mb-4">
          {title && (
            <h3 className="text-base font-semibold text-tf-text mb-1">{title}</h3>
          )}
          {subtitle && (
            <p className="text-sm text-tf-text-sub">{subtitle}</p>
          )}
        </div>
      )}
      {children}
    </div>
  );
}







